(() => {
  if (window.HalloweenProductSwatchesLoaded) return;
  window.HalloweenProductSwatchesLoaded = true;

  class HalloweenProductSwatches {
    constructor(card) {
      this.card = card;
      this.image = card.querySelector('.halloween-product-card__media img');
      this.swatches = Array.from(card.querySelectorAll('[data-halloween-product-swatch]'));
      this.links = Array.from(card.querySelectorAll('[data-halloween-product-link]'));
      this.productUrl = card.dataset.productUrl;

      card.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-halloween-product-swatch]');
        if (swatch && card.contains(swatch)) this.select(swatch);
      });
    }

    select(swatch) {
      this.swatches.forEach((item) => {
        const isActive = item === swatch;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });

      this.updateImage(swatch);
      this.updateLinks(swatch.dataset.variantId);
    }

    updateImage(swatch) {
      const nextImage = swatch.dataset.image;
      if (!nextImage || !this.image || this.image.currentSrc === nextImage || this.image.src === nextImage) return;

      const preload = new Image();
      preload.onload = () => {
        this.image.removeAttribute('srcset');
        this.image.src = nextImage;
        this.image.alt = swatch.dataset.imageAlt || this.image.alt;
      };
      preload.src = nextImage;
    }

    updateLinks(variantId) {
      if (!this.productUrl || !variantId) return;
      const url = new URL(this.productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      const variantUrl = `${url.pathname}${url.search}${url.hash}`;
      this.links.forEach((link) => { link.href = variantUrl; });
    }
  }

  const initializeHalloweenProductSwatches = (root = document) => {
    root.querySelectorAll('[data-halloween-product-card]').forEach((card) => {
      if (card.dataset.halloweenProductSwatchesInitialized) return;
      card.dataset.halloweenProductSwatchesInitialized = 'true';
      new HalloweenProductSwatches(card);
    });
  };

  const scheduleInitialization = (root = document) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeHalloweenProductSwatches(root), { once: true });
    } else {
      initializeHalloweenProductSwatches(root);
    }
  };

  scheduleInitialization();
  document.addEventListener('shopify:section:load', (event) => scheduleInitialization(event.target));
})();
